export const roundMoney = (value) => Math.round(value * 100) / 100;
// eslint-disable-next-line no-empty-function
export const noop = () => {};
